import { Form } from 'antd';
import style from './index.module.scss';
import {
  Button,
  ContentLayout,
  Input,
  Logo,
  PageLayout,
  Switch,
} from 'components';
import { useCallback } from 'react';
import { useAuth } from 'hooks/useAuth';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useWatchForm } from 'hooks/useWatchForm';

export type TSignUpData = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

export const SignUp = () => {
  const { signUp, isLoading } = useAuth();
  const [form] = Form.useForm();
  const { isValid } = useWatchForm({ form });

  const onFinish = useCallback(
    async (data: TSignUpData) => {
      await signUp(data);
    },
    [signUp],
  );

  const seeTerms = () => {
    window.location.href = 'https://aqnllamo.com/terms-of-use-for-workers/';
  };

  return (
    <PageLayout className={style.signup}>
      <ContentLayout>
        <Logo className={style.logo} />

        <Form layout={'vertical'} form={form} onFinish={onFinish}>
          <Form.Item
            name="firstName"
            rules={[{ required: true, message: 'Nombre es requerido' }]}
          >
            <Input maxLength={20} label="Nombre" />
          </Form.Item>

          <Form.Item
            name="lastName"
            rules={[{ required: true, message: 'Apellido es requerido' }]}
          >
            <Input maxLength={20} label="Apellido" />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Email es requerido' },
              { type: 'email', message: 'Email invalido' },
            ]}
          >
            <Input maxLength={40} label="Dirección de Correo" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Contraseña es requerido' },
              { min: 6, message: 'Minimo 6 caracteres' },
            ]}
          >
            <Input
              type="password"
              onChange={() => form.setFieldValue('repeatPass', null)}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              maxLength={16}
              minLength={6}
              label="Contraseña"
            />
          </Form.Item>

          <Form.Item
            name="repeatPass"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Confirmar Contraseña es requerido' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('Las contraseñas no coinciden'),
                  );
                },
              }),
            ]}
          >
            <Input
              label="Confirmar Contraseña"
              type="password"
              maxLength={16}
              minLength={6}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>

          <Form.Item
            valuePropName="checked"
            name="terms"
            rules={[{ required: true, message: 'Debes aceptar' }]}
          >
            <Switch
              onChange={(checked) =>
                form.setFieldValue('terms', checked ? true : null)
              }
              label={
                <p className={style.terms}>
                  He leído y acepto los
                  <p onClick={seeTerms}>Términos y Condiciones</p>
                </p>
              }
            />
          </Form.Item>

          <Button
            loading={isLoading}
            disabled={!isValid}
            htmlType="submit"
            className={style.button}
            buttonType="solid"
            shape="round"
          >
            REGISTRARSE
          </Button>
        </Form>
      </ContentLayout>
    </PageLayout>
  );
};
